import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/products',

    defaults : {
        "id" : "",
        "client_id" : "",
        "name" : "",
        "description" : "",
        "model": "Bike",
        "serial": "",
        "manufacturer": "",
        "frame_number": "",
        "frame_size": "",
        "created": null,
        "modified": null,
        "deleted": null,
        "discountable": false,
        "external_product_id": null,
        "external_attributes": null,
        "UVP": 5000,
        "type": "",
        "layout_type": "",
        "products_products": [],
        "contingents": [],
        "pricetariffs": [],
        'prices': [],
        "image": ""
    }
})